import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import BenefitsSection from "./components/BenefitsSection";
import ProductsSection from "./components/ProductsSection";
import PhasesSection from "./components/PhasesSection";
import CropsSection from "./components/CropsSection";
import WhyLLKSection from "./components/WhyLLKSection";
import AuthoritySection from "./components/AuthoritySection";
import ContactFormSection from "./components/ContactFormSection";
import CTAFinalSection from "./components/CTAFinalSection";
import FooterSection from "./components/FooterSection";
import WhatsAppButton from "./components/WhatsAppButton";
import ExitPopup from "./components/ExitPopup";

export default function Home() {
  return (
    <main className="relative w-full overflow-x-hidden bg-llk-cream font-sans">
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <BenefitsSection />
      <ProductsSection />
      <PhasesSection />
      <CropsSection />
      <WhyLLKSection />
      <AuthoritySection />
      <ContactFormSection />
      <CTAFinalSection />
      <FooterSection />
      <WhatsAppButton />
      <ExitPopup />
    </main>
  );
}